export default {
  MuiLink: {
    root: {
      cursor: 'pointer',
    },
    underlineHover: {
      '&:hover': {
        color: '#26A69A',
        textDecoration: 'none',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Link.js